<template>
    <Float
        placement="bottom-end"
        :offset="6"
        enter="transition-all duration-300 ease-out"
        enter-from="opacity-0 -translate-y-1"
        enter-to="opacity-100 translate-y-0"
        leave="transition-all duration-150 ease-in"
        leave-from="opacity-100 translate-y-0"
        leave-to="opacity-0 -translate-y-1"
        composable
        :show="notificationAreaOpened"
    >
        <FloatReference>
            <UiHeaderButton class="relative" @click="handleClickToggle">
                <notification-badge />
                <icon icon="hero/outline/bell" class="w-5 h-5 cursor-pointer"></icon>
            </UiHeaderButton>
        </FloatReference>

        <FloatContent>
            <ui-popover class="!w-80" @click-outside="handleClickOutside">
                <ui-popover-section>
                    <ui-popover-header>
                        <ui-popover-headline>
                            {{ lang('notifications::notifications.title') }}
                        </ui-popover-headline>
                        <ui-popover-subtitle class="flex items-center">
                            <button type="button" class="py-2 -mb-2 border-b-2 border-current text-medium">
                                {{ lang('notifications::notifications.sections.inbox') }}

                                <span class="inline-block px-1 text-xs rounded-full bg-neutral-50 dark:bg-neutral-950">
                                    {{ notification.total }}
                                </span>
                            </button>
                        </ui-popover-subtitle>
                    </ui-popover-header>
                    <ui-scrollable class="!h-[400px]" @arrived-bottom="handleArrivedBottom">
                        <ui-popover-segment>
                            <notification-area />
                        </ui-popover-segment>
                        <ui-popover-segment v-if="!isLoadedAll">
                            <div class="flex items-center justify-center h-4">
                                <div v-if="isLoading" class="animate-pulse">
                                    {{ lang('notifications::notifications.loading') }}
                                </div>
                            </div>
                        </ui-popover-segment>
                    </ui-scrollable>
                </ui-popover-section>
            </ui-popover>
        </FloatContent>
    </Float>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useNotificationArea } from '@src/Notifications/Pages/composables/useNotificationArea';
import NotificationArea from '@src/Notifications/Pages/NotificationArea.vue';
import NotificationBadge from '@src/Notifications/Pages/NotificationBadge.vue';
import { Float, FloatContent, FloatReference } from '@headlessui-float/vue';

const notification = useNotificationArea();
const notificationAreaOpened = computed(() => notification.opened.value);
const isLoading = computed(() => notification.loading.value.notifications);
const isLoadedAll = computed(() => notification.isLoadedAll.value);

const handleArrivedBottom = () => {
    notification.loadMore();
};

const blockToggle = ref(false);

const handleClickOutside = () => {
    blockToggle.value = true;
    notification.close();

    setTimeout(() => {
        blockToggle.value = false;
    }, 100);
};

const handleClickToggle = () => {
    if (blockToggle.value) {
        return;
    }

    notification.toggle();
};
</script>
